import { createUseQuery } from 'api/common/createUseQuery'

import { ApiQueryKeys } from './ApiQueryKeys'
import { fetchUserAssignedRolesApi } from './fetchers/fetchUserAssignedRoles'

export const useUserAssignedRolesApi = createUseQuery({
  queryKey: ApiQueryKeys.MEMBER_ROLES,
  fetcher: fetchUserAssignedRolesApi,
  selector: response => response?.data || [],
})
